import { CLIENT_PLATFORMS, LINK_FROM_APP_PLATFORMS } from '$lib/utils/constants';

/**
 * Maps app store meta + global link source to BI `client_platform`.
 * Shared by AML `client_context` (ApiService) and canonical pipeline client slice (Analytics).
 * @param {import('./types').App.Meta | undefined | null} meta - App meta (inApp, viewer flags).
 * @param {string | null | undefined} linkFromAppPlatform - `app.global.linkFromAppPlatform`
 * @returns {string | null} A `CLIENT_PLATFORMS` value, or null when unknown.
 */
export function resolveClientPlatform(meta, linkFromAppPlatform) {
	if (!meta) {
		return null;
	}

	if (linkFromAppPlatform === LINK_FROM_APP_PLATFORMS.IOS_1_0) {
		return CLIENT_PLATFORMS.ALT_PAYMENT_1_0;
	}
	if (linkFromAppPlatform === LINK_FROM_APP_PLATFORMS.ANDROID_1_0) {
		return CLIENT_PLATFORMS.ALT_PAYMENT_GOOGLE_1_0;
	}
	if (linkFromAppPlatform === LINK_FROM_APP_PLATFORMS.IOS_2_0) {
		return CLIENT_PLATFORMS.ALT_PAYMENT_2_0;
	}
	if (
		linkFromAppPlatform === LINK_FROM_APP_PLATFORMS.ANDROID ||
		linkFromAppPlatform === LINK_FROM_APP_PLATFORMS.ANDROID_2_0 ||
		linkFromAppPlatform === LINK_FROM_APP_PLATFORMS.SAMSUNG
	) {
		return CLIENT_PLATFORMS.ALT_PAYMENT_GOOGLE_2_0;
	}
	if (meta.inApp === true) {
		return CLIENT_PLATFORMS.IN_APP;
	}
	if (meta.inApp === false) {
		if (meta.isDesktopViewer) {
			return CLIENT_PLATFORMS.DESKTOP_BROWSER;
		}
		if (meta.isMobileViewer) {
			return CLIENT_PLATFORMS.MOBILE_BROWSER;
		}
	}

	return null;
}
